import React from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { X, Stethoscope } from "lucide-react";
import { BrandLogos } from "@/components/common/BrandLogos";

// Minimal chrome-free shell for "Present" mode — renders a single Command Center
// screen with no sidebar/top bar. Opened in a separate popup window.
export default function PresentLayout() {
  const navigate = useNavigate();
  const exit = () => {
    window.close();
    setTimeout(() => { if (!window.closed) navigate("/command"); }, 150);
  };
  return (
    <div className="min-h-screen hah-page-bg">
      {/* Brand strip — product brand always preserved, client logos alongside */}
      <div className="flex items-center gap-4 px-4 sm:px-6 lg:px-8 py-3 border-b border-black/5 bg-[#0B7E8C]">
        <div className="flex items-center gap-2.5">
          <div className="w-8 h-8 rounded-lg bg-white/15 flex items-center justify-center">
            <Stethoscope className="w-4.5 h-4.5 text-white" strokeWidth={2.2} />
          </div>
          <div className="leading-tight">
            <div className="text-white font-semibold text-sm">Hospital at Home</div>
            <div className="text-white/70 text-[10px] uppercase tracking-wider">Care Beyond Walls</div>
          </div>
        </div>
        <BrandLogos className="ml-1" />
        <button
          onClick={exit}
          data-testid="present-exit"
          style={{ backgroundColor: "#ffffff" }}
          className="ml-auto flex items-center gap-1.5 px-3 py-1.5 rounded-lg shadow-sm ring-1 ring-black/5 text-sm text-[#1F2937] hover:opacity-90 transition"
        >
          <X className="w-4 h-4" /> Exit
        </button>
      </div>
      <div className="px-4 sm:px-6 lg:px-8 py-6 max-w-[1600px] mx-auto">
        <Outlet />
      </div>
    </div>
  );
}
